import { isValidPhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js';

import { formatNumeric } from './numeric';

/**
 * Format mobile number.
 *
 * @param value - Mobile number string.
 * @returns Formatted mobile number string.
 */
export function formatMobileNumber(value?: string) {
  if (!value) {
    return '';
  }

  try {
    // Validate the phone number even it's incomplete with right prefixes.
    if (!isValidPhoneNumber(value, 'AU')) {
      if (value.startsWith('04')) {
        return formatNumeric(value, '#### ### ###');
      }
      if (value.startsWith('61')) {
        return formatNumeric(value, '## ### ### ###');
      }
      if (value.startsWith('+61')) {
        return formatNumeric(value, '+## ### ### ###');
      }
      // If not valid, return input as-is
      return value;
    }

    // Try to parse the phone number with Australian default country
    const phoneNumber = parsePhoneNumberWithError(value, 'AU');

    // Only format Australian numbers
    if (phoneNumber.country === 'AU') {
      // Return formatted Australian number in international or national format
      if (value.startsWith('+')) {
        return phoneNumber.formatInternational();
      }
      return phoneNumber.formatNational();
    }
    // For other countries, return input as-is
    return value;
  } catch {
    // If parsing fails, return input as-is
    return value;
  }
}

/**
 * Get country flag svg url by mobile number.
 *
 * @param mobileNumber - Mobile number from any country
 * @returns Country flag svg url
 */
export function getCountryFlagUrl(mobileNumber?: string) {
  let countryCode = 'AU';

  if (mobileNumber) {
    try {
      // Try to parse without default country to detect the actual country
      const phoneNumber = parsePhoneNumberWithError(mobileNumber);
      if (phoneNumber?.country) {
        countryCode = phoneNumber.country;
      }
    } catch {
      // If parsing fails, try with AU as default country
      try {
        const phoneNumber = parsePhoneNumberWithError(mobileNumber, 'AU');
        if (phoneNumber?.country) {
          countryCode = phoneNumber.country;
        }
      } catch {
        // If still fails, keep default AU
      }
    }
  }

  return `https://flagcdn.com/${countryCode.toLowerCase()}.svg`;
}
